import React from 'react';

// project-imports
import { flatDeep, slugify, containsObject } from '../../../utils';
import { Link } from 'react-router-dom';
import { ADMIN, DEV } from '../../../constants/entityType';

// third-party

const EBookCategoryOne = (props) => {

    // Property initialization 
    const { ebooks, allEbooks, handleChangeCategory, selectedCategory } = props;

    // Constant variable

    const allCats = (allEbooks || []).map(item => {
        const cat = item && item?.category ? (item?.category).toLowerCase() : "Salesforce";
        const subCatName = item && item?.subCategory ? item?.subCategory.toLowerCase() === ADMIN ? item?.subCategory.toLowerCase() : DEV : "ebook";
        return {
            cat, subCatName
        };
    });

    const cats = (ebooks || []).map(item => {
        const cat = item && item?.category ? (item?.category).toLowerCase() : "Salesforce";
        const subCatName = item && item?.subCategory ? item?.subCategory.toLowerCase() === ADMIN ? item?.subCategory.toLowerCase() : DEV : "ebook";
        return {
            cat, subCatName
        };;
    });

    let singleAllCatArray = allCats || [];
    let singleCatArray = cats || [];

    let CategoryCountMap = {};

    (singleCatArray || []).forEach(item => {
        const key = `${item.cat}__${item.subCatName}`;
        CategoryCountMap[key] = (CategoryCountMap[key] || 0) + 1;
    });

    let categoriesMap = {};
    
    (singleAllCatArray || []).forEach(category => {
        const cat = category?.cat;
        const subCat = category?.subCatName;

        const key = `${cat}__${subCat}`;

        const count = (singleCatArray || []).filter(c => c?.cat === cat && c?.subCatName === subCat).length;

        if (!categoriesMap[key]) {
            categoriesMap[key] = {
                title: cat,
                cat: cat,
                subCat: subCat,
                slug: `${cat} ${subCat}`,
                count: CategoryCountMap[key] || 0
            };
        }
    });

    const categories = Object.values(categoriesMap);

    return (

        <div className={`edu-blog-widget${props.style2 === 'enable' ? '-2' : ''} widget-categories ${props.extraClass || ''}`}>
            <div className="inner">
                <h5 className="widget-title">Categories</h5>
                <div className="content">
                    <ul className="category-list">
                        {Boolean(allEbooks && !allEbooks.length) &&
                            <h6 className="title">Oops... No categories Found!</h6>
                        }

                        {Boolean(categories && categories.length) &&
                            categories.map((category, i) => {
                                return (
                                    <button key={i}
                                        className={`edu-btn btn-small btn-shade w-full mb-1 fs-15 text-capitalize ${category?.count === 0 ? "custom-disabled" : ""} ${selectedCategory?.cat?.toLowerCase() === category?.cat?.toLowerCase() && selectedCategory?.subCat?.toLowerCase() === category?.subCat?.toLowerCase() && category?.count != 0 ? "active-category" : ""}`}
                                        onClick={() => category?.count > 0 && handleChangeCategory(category)}
                                    >
                                        {category?.cat} {category?.subCat}<span> ({category?.count})</span>
                                    </button>
                                )
                            })
                        }
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default EBookCategoryOne;